import { API } from "../../../utils";

export const getLanguagesApi = async () => {
  const res = await API.get("/languages");
  return res.data;
};

export const getCurrenciesApi = async () => {
  const res = await API.get("/currencies");
  return res.data;
};

export const getTenantRegionSettingsApi = async () => {
  const res = await API.get("/settings/currency_lang_timezone");
  return res.data;
};

export const updateTenantRegionSettingsApi = async (payload) => {
  const res = await API.put("/settings/currency_lang_timezone", payload);
  return res.data;
};